module.exports = __webpack_public_path__ + "static/media/bp_icn_pro.dae4db5a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/bp_icn_pro.png
 ** module id = 251
 ** module chunks = 0
 **/